// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonText_container__2e04c"};